/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { ConstructionActionAreaBase } from "../../../../schema/generated/ConstructionActionArea";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class ConstructionActionAreaDataApi extends EntityDataApi<ConstructionActionAreaBase> {
  public readonly def = idbEntityDefs.ConstructionActionArea;
}